import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box, Switch, FormControlLabel,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { geraStringAleatoria } from "../../utils/geraStringAleatoria";

const useStyles = makeStyles((theme) => ({
  dialogTitle: { background: "#6d28d9", color: "#fff", padding: theme.spacing(2) },
  infoBox: { background: "#ede9fe", border: "1px solid #ddd6fe", borderRadius: 8, padding: theme.spacing(1.5), marginBottom: theme.spacing(2) },
  infoText: { fontSize: "0.82rem", color: "#4c1d95", lineHeight: 1.6 },
}));

const DEFAULT = { descricao: "", valor: "", valorVar: "", msgEnvio: "Segue seu link de pagamento InfinityPay:" };

const FlowBuilderInfinityPayModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [cfg, setCfg] = useState(DEFAULT);
  const [usarVar, setUsarVar] = useState(false);

  useEffect(() => {
    if (open === "edit" && data?.data?.data) {
      const d = data.data.data;
      setCfg({
        descricao: d.descricao || "",
        valor: d.valor || "",
        valorVar: d.valorVar || "",
        msgEnvio: d.msgEnvio || DEFAULT.msgEnvio,
      });
      setUsarVar(!!d.valorVar);
    } else if (open === "create") {
      setCfg(DEFAULT);
      setUsarVar(false);
    }
  }, [open, data]);

  const handleSave = () => {
    const saved = { ...cfg, valorVar: usarVar ? cfg.valorVar : "", valor: usarVar ? "" : cfg.valor };
    if (open === "edit") {
      onUpdate(data.id, { data: { label: "InfinityPay", data: saved } });
    } else {
      onSave({ label: "InfinityPay", data: saved, id: geraStringAleatoria(30) });
    }
    close();
  };

  return (
    <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle className={classes.dialogTitle}>InfinityPay — Link de Pagamento</DialogTitle>
      <DialogContent>
        <Box className={classes.infoBox}>
          <Typography className={classes.infoText}>
            Gera um link de checkout InfinityPay e envia ao cliente.<br />
            O link aceita cartão de crédito e PIX. Salva{" "}
            <strong>{"{{infinitypay_link}}"}</strong> e{" "}
            <strong>{"{{infinitypay_order_nsu}}"}</strong> nas variáveis do fluxo.
          </Typography>
        </Box>

        <TextField
          label="Descrição do item"
          value={cfg.descricao}
          onChange={(e) => setCfg({ ...cfg, descricao: e.target.value })}
          fullWidth margin="dense" variant="outlined"
          helperText="Suporta variáveis: ex {{nome_produto}}"
        />

        <FormControlLabel
          control={<Switch checked={usarVar} onChange={(e) => setUsarVar(e.target.checked)} color="primary" />}
          label="Usar variável para o valor"
          style={{ marginTop: 8, marginBottom: 4 }}
        />

        {usarVar ? (
          <TextField
            label="Variável com o valor (em reais)"
            value={cfg.valorVar}
            onChange={(e) => setCfg({ ...cfg, valorVar: e.target.value })}
            fullWidth margin="dense" variant="outlined"
            helperText="Ex: valor_fatura → usa {{valor_fatura}} (número em reais)"
          />
        ) : (
          <TextField
            label="Valor fixo (R$)"
            value={cfg.valor}
            onChange={(e) => setCfg({ ...cfg, valor: e.target.value })}
            fullWidth margin="dense" variant="outlined" type="number"
            helperText="Valor em reais. Ex: 59.90"
          />
        )}

        <TextField
          label="Mensagem enviada com o link"
          value={cfg.msgEnvio}
          onChange={(e) => setCfg({ ...cfg, msgEnvio: e.target.value })}
          fullWidth multiline rows={2} margin="dense" variant="outlined"
          helperText="Texto enviado antes do link de pagamento"
        />

        <Box style={{ marginTop: 12, padding: 12, background: "#f5f3ff", borderRadius: 8, border: "1px solid #ddd6fe" }}>
          <Typography style={{ fontSize: "0.8rem", color: "#4c1d95", fontWeight: 600, marginBottom: 4 }}>Saídas</Typography>
          <Typography style={{ fontSize: "0.8rem", color: "#6d28d9" }}>
            🟢 <strong>link_enviado</strong> — link gerado e enviado com sucesso<br />
            🔴 <strong>erro</strong> — falha ao gerar link (credenciais, API)
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderInfinityPayModal;
